// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as EtaRouteImport } from './routes/eta'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as LoginRouteImport } from './routes/login'
import { Route as McpInstructionsRouteImport } from './routes/mcp-instructions'
import { Route as OpenapiRouteImport } from './routes/openapi'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminApiKeysRouteImport } from './routes/admin/api-keys'
import { Route as AdminEtaSettingsRouteImport } from './routes/admin/eta-settings'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as DispatchSessionIdRouteImport } from './routes/dispatch.$sessionId'
import { Route as GuideIndexRouteImport } from './routes/guide/index'
import { Route as GuideAnalyticsRouteImport } from './routes/guide/analytics'
import { Route as GuideConceptsRouteImport } from './routes/guide/concepts'
import { Route as GuideDispatchRouteImport } from './routes/guide/dispatch'
import { Route as GuideEtaRouteImport } from './routes/guide/eta'
import { Route as GuideGettingStartedRouteImport } from './routes/guide/getting-started'
import { Route as GuideAdminSettingsUsersRolesRouteImport } from './routes/guide/admin-settings/users-roles'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const CallbackRoute = CallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => rootRouteImport
          })
const EtaRoute = EtaRouteImport.update({
            id: '/eta',path: '/eta',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const McpInstructionsRoute = McpInstructionsRouteImport.update({
            id: '/mcp-instructions',path: '/mcp-instructions',getParentRoute: () => rootRouteImport
          })
const OpenapiRoute = OpenapiRouteImport.update({
            id: '/openapi',path: '/openapi',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminApiKeysRoute = AdminApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AdminRoute
          })
const AdminEtaSettingsRoute = AdminEtaSettingsRouteImport.update({
            id: '/eta-settings',path: '/eta-settings',getParentRoute: () => AdminRoute
          })
const AdminRolesRoute = AdminRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const DispatchSessionIdRoute = DispatchSessionIdRouteImport.update({
            id: '/dispatch/$sessionId',path: '/dispatch/$sessionId',getParentRoute: () => rootRouteImport
          })
const GuideIndexRoute = GuideIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuideRoute
          })
const GuideAnalyticsRoute = GuideAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => GuideRoute
          })
const GuideConceptsRoute = GuideConceptsRouteImport.update({
            id: '/concepts',path: '/concepts',getParentRoute: () => GuideRoute
          })
const GuideDispatchRoute = GuideDispatchRouteImport.update({
            id: '/dispatch',path: '/dispatch',getParentRoute: () => GuideRoute
          })
const GuideEtaRoute = GuideEtaRouteImport.update({
            id: '/eta',path: '/eta',getParentRoute: () => GuideRoute
          })
const GuideGettingStartedRoute = GuideGettingStartedRouteImport.update({
            id: '/getting-started',path: '/getting-started',getParentRoute: () => GuideRoute
          })
const GuideAdminSettingsUsersRolesRoute = GuideAdminSettingsUsersRolesRouteImport.update({
            id: '/admin-settings/users-roles',path: '/admin-settings/users-roles',getParentRoute: () => GuideRoute
          })





const AdminRouteChildren = {
  AdminApiKeysRoute: AdminApiKeysRoute,AdminEtaSettingsRoute: AdminEtaSettingsRoute,AdminRolesRoute: AdminRolesRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const GuideRouteChildren = {
  GuideAnalyticsRoute: GuideAnalyticsRoute,GuideConceptsRoute: GuideConceptsRoute,GuideDispatchRoute: GuideDispatchRoute,GuideEtaRoute: GuideEtaRoute,GuideGettingStartedRoute: GuideGettingStartedRoute,GuideIndexRoute: GuideIndexRoute,GuideAdminSettingsUsersRolesRoute: GuideAdminSettingsUsersRolesRoute
}

const GuideRouteWithChildren = GuideRoute._addFileChildren(GuideRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AnalyticsRoute: AnalyticsRoute,CallbackRoute: CallbackRoute,EtaRoute: EtaRoute,GuideRoute: GuideRouteWithChildren,LoginRoute: LoginRoute,McpInstructionsRoute: McpInstructionsRoute,OpenapiRoute: OpenapiRoute,SettingsRoute: SettingsRoute,DispatchSessionIdRoute: DispatchSessionIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)